"use client";

export interface SvgFadeMaskProps {
  id: string;
  edgePct?: number;
}

export function SvgFadeMask({ id, edgePct = 6 }: SvgFadeMaskProps) {
  const start = edgePct / 100;
  const end = 1 - start;
  return (
    <defs>
      <linearGradient id={`${id}-grad`} x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stopColor="white" stopOpacity="0" />
        <stop offset={String(start)} stopColor="white" stopOpacity="1" />
        <stop offset={String(end)} stopColor="white" stopOpacity="1" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <mask id={id}>
        <rect width="100%" height="100%" fill={`url(#${id}-grad)`} />
      </mask>
    </defs>
  );
}
